<template>
  <div class="component-header">
    <div class="component-header__leftTitle">
      <img :src="require('@/assets/img/other/header.svg')">
      <span>不动产垂直领域数字化服务平台</span>
    </div>
    <div class="component-header__rightTitle">
      <span>{{getCurrentDate()}}</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getCurrentDate() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return `${year}年${month}月${day}日`;
    }
  }
};
</script>

<style lang="less" scoped>
.component-header {
  height: 72px;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(13, 16, 34, 1) 0%,
    rgba(11, 25, 90, 1) 100%
  );
  border-radius: 0px 0px 64px 64px;
  opacity: 0.9;
  border: 1px solid rgba(0,170,255,0.2);
  border-top:none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
  box-shadow:0 12px 12px rgba(0, 7, 90, 0.8);

  .component-header__leftTitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 0px 8px rgba(0, 53, 255, 0.5);
    display: flex;
    align-items: center;
    width: max-content;

    img {
      height: 18px;
      margin-right: 16px;
    }

    span{
      border-left: 1px solid rgba(255, 255, 255, 0.3);
      padding-left: 16px;
      display: inline-block;
      min-width: max-content;
      line-height: 18px;
      white-space: nowrap;
    }
  }
  .component-header__rightTitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 0px 8px rgba(0, 53, 255, 0.5);
    line-height: 20px;
  }
}
</style>